export const getInitialsCompanyName = (companyName: string): string => {
  return companyName
    ? companyName
        .match(/\b(\w)/g)
        .join('')
        .substring(0, 2)
    : 'A'
}
